module.exports = __webpack_public_path__ + "static/img/白色底部@2x.8eb4cbb8.png";